<template>
  <div :class="['modal', { 'is-active': show }]">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Add Existing User</p>
        <button class="delete" v-on:click="hideModal"></button>
      </header>
      <section class="modal-card-body">
        <form @submit.prevent="submit">
          <div class="field is-grouped">
            <div class="control is-expanded">
              <input
                type="search"
                class="input"
                v-model="query"
                name="search"
                placeholder="Search users"
                autofocus
              />
            </div>
            <p class="control">
              <button type="submit" class="button is-info mt1">
                <span v-if="!working">Search</span>
                <i class="fa fa-refresh fa-spin" v-if="working"></i>
              </button>
            </p>
          </div>
        </form>

        <table class="table is-striped" v-if="!working">
          <tr v-for="user in Object.values(searchUsers)">
            <td>{{ user.attributes.firstName }}</td>
            <td>{{ user.attributes.lastName }}</td>
            <td>{{ user.attributes.email }}</td>
            <td class="has-text-right">
              <button type="button" class="button" @click="selectUser(user)">
                <span v-if="!showUserWorking(user)">Select</span>
                <i
                  class="fa fa-refresh fa-spin"
                  v-if="showUserWorking(user)"
                ></i>
              </button>
            </td>
          </tr>
        </table>

        <article
          class="message is-danger"
          v-if="!working && searchUsersMessage.length"
        >
          <div class="message-body">
            {{ searchUsersMessage }}
          </div>
        </article>
      </section>
      <footer class="modal-card-foot">
        <a class="button is-link" v-on:click="hideModal">Close</a>
      </footer>
    </div>
  </div>
</template>

<script>
import PracticesService from "../../services/PracticesService";

export default {
  name: "existing-user-modal",

  props: ["show", "hide", "errorMessage", "practiceId"],

  data() {
    return {
      query: "",
      working: false,
      userAddWorking: null
    };
  },

  methods: {
    hideModal() {
      this.$props.hide();
    },
    submit() {
      this.working = true;
      PracticesService.userSearch(this.query).then(() => {
        this.working = false;
      });
    },
    selectUser(user) {
      this.userAddWorking = user.id;
      let practiceId = this.$props.practiceId;
      if (!practiceId) {
        const practice = this.$store.getters["practice/current"];
        practiceId = practice.id;
      }
      PracticesService.addUser(practiceId, user.id)
        .then(() => {
          this.userAddWorking = null;
          this.hide();
        })
        .catch(() => {
          this.userAddWorking = null;
          this.errorMessage("This user has already been added.");
        });
    },
    showUserWorking(user) {
      return user.id === this.userAddWorking;
    }
  },

  computed: {
    searchUsers() {
      return this.$store.getters["practice/getSearchUsers"];
    },
    searchUsersMessage() {
      return this.$store.getters["practice/userSearchMessage"];
    }
  }
};
</script>

<style lang="scss" scoped></style>
